import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    background-color: ${({ theme }) => theme.colors.bg};
    color: ${({ theme }) => theme.colors.text.primary};
    font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;
    line-height: 1.55;
    font-weight: 400;
    letter-spacing: -0.01em;
    overflow-x: hidden;
  }

  ::selection {
    background: #FF5B3A;
    color: #ECE8E0;
  }

  ::-webkit-scrollbar {
    width: 0px;
    display: none;
  }

  * {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;
    font-weight: 600;
    line-height: 1.1;
    margin-bottom: 0.5em;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.colors.text.primary};
  }

  p {
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.text.secondary};
  }

  a {
    text-decoration: none;
    color: inherit;
    transition: color 120ms cubic-bezier(0.16,1,0.3,1);
  }

  button {
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
    font-family: 'Space Grotesk', -apple-system, BlinkMacSystemFont, sans-serif;
    font-weight: 500;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  @media (max-width: 768px) {
    html {
      font-size: 14px;
    }
  }
`;

export default GlobalStyles;
